import DefaultDocumentsAcceptance from "./DocumentsAcceptance";

export default DefaultDocumentsAcceptance;
